import { render, staticRenderFns } from "./ModalSendStaffInvite.vue?vue&type=template&id=333dd9ca&"
import script from "./ModalSendStaffInvite.vue?vue&type=script&lang=js&"
export * from "./ModalSendStaffInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports